import { useEffect, useState } from "react";
import { HandSoap, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

const oops = (e) => toast.error(formatApiErrorDetail(e?.response?.data?.detail));

/** The food-handling record: a tick for every wash, and the day's roll-up for an admin. */
export const Handwash = () => {  const [data, setData] = useState(null);
  const [pick, setPick] = useState({ place: "Restroom", reason: "before food" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/facilities/handwash").then(({ data: d }) => setData(d)).catch(() => setData(null));
  useEffect(() => { load(); }, []);

  if (!data) return null;

  const tick = async () => {
    setBusy(true);
    try { await api.post("/facilities/handwash", pick); toast.success("Logged — thank you"); load(); }
    catch (e) { oops(e); } finally { setBusy(false); }
  };

  return (
    <section className="mt-8 border border-[#0B5C2E] bg-white p-4 sm:p-5" data-testid="handwash-panel">
      <p className="overline text-[#0B5C2E]">
        <HandSoap size={14} className="mr-1 inline align-[-2px]" />Hand washing record
      </p>
      <p className="mt-1 text-sm text-slate-600">
        Tick it and it goes on the food-handling record. You have logged{" "}
        <span className="font-semibold text-[#0F172A]" data-testid="handwash-my-count">{data.my_count}</span> today.
      </p>
      <div className="mt-3 grid gap-2 sm:grid-cols-[1fr_1fr_auto]">
        <select data-testid="handwash-place" value={pick.place}
          onChange={(e) => setPick({ ...pick, place: e.target.value })}
          className="tap-safe border border-border bg-white px-3 py-2 text-sm">
          {data.places.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
        <select data-testid="handwash-reason" value={pick.reason}
          onChange={(e) => setPick({ ...pick, reason: e.target.value })}
          className="tap-safe border border-border bg-white px-3 py-2 text-sm">
          {data.reasons.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
        <Button size="sm" data-testid="handwash-log" onClick={tick} disabled={busy}>
          <Check size={14} className="mr-1.5" /> I washed up
        </Button>
      </div>

      {data.mine?.length > 0 && (
        <ul className="mt-3 space-y-0.5 text-sm text-slate-700" data-testid="handwash-mine">
          {data.mine.slice(0, 5).map((row, i) => (
            <li key={i}>{row.at.slice(11, 16)} · {row.place} · {row.reason}</li>
          ))}
        </ul>
      )}

      {data.by_person && (
        <div className="mt-4 border-t border-border pt-3" data-testid="handwash-record">
          <p className="text-sm font-semibold text-[#0F172A]">
            Today across the site: {data.total} washes logged
          </p>
          <ul className="mt-1 space-y-0.5 text-sm text-slate-700">
            {data.by_person.slice(0, 8).map((row) => (
              <li key={row.name}>{row.name} · {row.washes}</li>
            ))}
          </ul>
          <Button className="mt-2" size="sm" variant="outline" data-testid="handwash-nudge"
            onClick={async () => {
              try { const { data: d } = await api.post("/facilities/handwash/nudge");
                toast.success(d.sent ? `Reminder sent to ${d.sent} people` : d.reason); }
              catch (e) { oops(e); }
            }}>
            Remind everyone now
          </Button>
        </div>
      )}
    </section>
  );
};
